import React from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import Calendar from 'rc-calendar'
import moment from 'moment'
import classNames from 'classnames'
import { Controller } from 'react-hook-form'

import { isDateInPast } from 'helpers/date'
import { formatErrorMessage } from 'helpers/contactRequestForm'
import { DEFAULT_START_TIME, DEFAULT_END_TIME } from 'components/ContactRequestFormComponents/constants'

import Icon from 'components/Icon'
import EventTimes from 'components/EventTimes'

import './index.less'

const DateTimerangePicker = (props) => {
  const {
    className,
    intl,
    hideErrors,
    initialData,
  } = props

  const initialDate = initialData?.requestedDates?.[0] || initialData?.requestedDates
  const initialMomentDate = initialDate && moment(initialDate)

  return (
    <div className={classNames('date-timerange-picker', className)}>
      <Controller
        name="requestedDates"
        defaultValue={initialMomentDate}
        rules={{ required: formatErrorMessage(intl, null, 'empty') }}
        render={({
          field: { onChange, onBlur, value, ref },
        }) => (
          <Calendar
            prefixCls="date-timerange-picker__calendar"
            showToday={false}
            showDateInput={false}
            disabledDate={isDateInPast}
            defaultSelectedValue={value}
            nextMonthIcon={<Icon name="angle-right" />}
            prevMonthIcon={<Icon name="angle-left" />}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
          />
        )}
      />

      <div className="date-timerange-picker__times">
        <EventTimes
          rowProps={{ gutter: 24 }}
          initialStartTime={initialData?.timesStartsAt || DEFAULT_START_TIME}
          initialEndTime={initialData?.timesEndsAt || DEFAULT_END_TIME}
          hideErrors={hideErrors}
        />
      </div>
    </div>
  )
}

DateTimerangePicker.propTypes = {
  className: PropTypes.string,
  intl: PropTypes.object.isRequired,
  errorCallback: PropTypes.func,
  hideErrors: PropTypes.bool,
  initialValue: PropTypes.array,
  onChange: PropTypes.func,
  initialData: PropTypes.shape({
    requestedDates: PropTypes.array,
    timesStartsAt: PropTypes.string,
    timesEndsAt: PropTypes.string,
  }),
}

export default injectIntl(DateTimerangePicker)
